import { usePage } from '@inertiajs/react'
import SiteForm from './SiteForm'
import { t } from '@/shared/lib/i18n'
import { sitePath, sitesPath, organizationPath } from '@/shared/lib/routes'
import { useBreadcrumbs } from '@/shared/lib/breadcrumbs-context'
import type { WebSiteForm } from '@/shared/types/web'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface TimezoneOption {
  value: number
  label: string
}

interface CountryOption {
  value: number
  label: string
  phoneCode: string
}

interface Props {
  timezones: TimezoneOption[]
  countries: CountryOption[]
  site: WebSiteForm
  customDaySchedule: WeekdaySchedule
  parentDaySchedule: WeekdaySchedule
  [key: string]: unknown
}

const EditSitePage = () => {
  const { timezones, countries, site, customDaySchedule, parentDaySchedule } =
    usePage<Props>().props

  useBreadcrumbs([
    { label: t('nav.administration'), href: organizationPath() },
    { label: t('nav.sites'), href: sitesPath() },
    { label: t('organization.sites.edit') },
  ])

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">
        {t('organization.sites.edit')}: {site.name}
      </h1>
      <SiteForm
        timezones={timezones}
        countries={countries}
        initialData={site}
        customDaySchedule={customDaySchedule}
        parentDaySchedule={parentDaySchedule}
        submitUrl={sitePath(site.id)}
        submitMethod="patch"
      />
    </div>
  )
}

export default EditSitePage
